<template>


  <div id="app">

   
    
 <head>
	<meta charset="UTF-8">
	<meta name="viewport" content="width=device-width, initial-scale=1">
    <title><img src="../src/assets/img/logo1.png" alt="">EPET N° 16 - Rincón de Los Sauces</title>
	<link rel="stylesheet" href="../css/font-awesome.min.css">
	<link rel="stylesheet" href="../css/normalize.css">
	<link rel="stylesheet" href="../css/bootstrap.min.css">
	<link href='http://fonts.googleapis.com/css?family=PT+Sans+Narrow' rel='stylesheet' type='text/css'>
	<link href='http://fonts.googleapis.com/css?family=Fjalla+One' rel='stylesheet' type='text/css'>
	<link rel="stylesheet" href="./css/style.css">
    
    
   
  </head>
  
    
      
      
  


<body>

    

    


  <nav class="navbar navbar-expand-lg navbar-light" style="background-color: #3f51b5">


  <div class="container-fluid">
   
    <a class="navbar-brand" href="#">EPET N°16</a>
    <img src="../src/assets/logo.png" alt="" width="30" height="24" class="d-inline-block align-text-top">
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="#"><router-link class="btn btn-primary" style="background-color: #3f51b5" to="/inicio">Inicio</router-link></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#"><router-link class="btn btn-primary" style="background-color: #3f51b5" to="/Institucion">Institucion</router-link></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#"><router-link class="btn btn-primary" style="background-color: #3f51b5" to="/Especialidad">Especialidad</router-link></a>
        </li>
        <li class="nav-item">
          <a class="nav-link"><router-link class="btn btn-primary" style="background-color: #3f51b5" to="/Secretaria">Secretaría</router-link></a>
        </li>
        <li class="nav-item">
          <a class="nav-link"><router-link class="btn btn-primary" style="background-color: #3f51b5" to="/Programas">Programas</router-link></a>
        </li>
         <li class="nav-link">
              <a class="btn btn-primary" href="#" data-bs-toggle="dropdown" style="background-color: #3f51b5">Mas&nbsp;<i class="fa fa-caret-down"></i></a>        
             	<div class="dropdown-menu megamenu" role="menu" style="background-color: #3f51b5">
				<div class="container">
				<div class="row">
				<div class="col-xs-12 col-sm-4">
				<span class="full-reset titles">Recursos educativos</span>
				<ul class="list-unstyled full-reset">
				<li><a href="https://scratch.mit.edu/" class="open-link-newTab" style=color:#FFF ><i class="fa fa-search" ></i>&nbsp;scratch</a></li>
							<li><a href="https://lazos.neuquen.edu.ar/" class="open-link-newTab" style=color:#FFF><i class="fa fa-graduation-cap"></i>&nbsp;Plataforma Lazos</a></li>
						</ul>
					</div>
					<div class="col-xs-12 col-sm-4">
						<span class="full-reset titles">Enlaces importantes</span>
						<ul class="list-unstyled full-reset">
							<li><a href="https://www.uncoma.edu.ar/" class="open-link-newTab" style=color:#FFF><i class="fa fa-university"></i>&nbsp;Universidad del Comahue</a></li>							
							<li><a href="https://www.argentina.gob.ar/jefatura/instituto-nacional-de-juventud" style=color:#FFF><i class="fa fa-globe" style=color:#FFF></i>&nbsp; JOVENES </a></li>
							<li><a href="https://utn.edu.ar/es/" class="open-link-newTab" style=color:#FFF><i class="fa fa-flask"></i>&nbsp;UTN</a></li>							
						</ul>
					</div>
					<div class="col-xs-12 col-sm-4">
						<span class="full-reset titles">Archivos</span>
						<ul class="list-unstyled full-reset" style=color:#FFF>
							<li><a href="https://drive.google.com/file/d/1uLcZOBEOoCqvmq_9mxhS1GSPaXF211nV/view?usp=sharing" style=color:#FFF><i class="fa fa-star-o"></i>&nbsp; Resolución 151 </a></li>
							
							<li><a href="Programas.html" style=color:#FFF><i class="fa fa-download"></i>&nbsp; Descargar programas</a></li>
						</ul>
					</div>
				</div>
			</div>
			</div>
           
        </li>
       
      </ul>
    </div>    
  </div>
</nav>





</body>
        <div>        



       
        
      </div>



 

 


 



  







     
    
    
	
   
   
 <router-view/>
   <footer class="text-center text-white" style="background-color: #3f51b5">
    

		 
		<div class="full-reset" style="padding: 15px 0;">
			<div class="container">
				<div class="row">
					
					<div class="col-xs-12 col-sm-4">
						<h4 class="titles text-center">Visitenos en</h4>
						<p class="text-center">EPET N° 16-Auca Mahuida 1047-Rincón De Los Sauces-Neuquén</p>
					</div>
					<div class="col-xs-12 col-sm-4">
						<h4 class="titles text-center">Contactenos</h4>
						<p class="text-center">Teléfono: (299)4886424 <br>Correo Electrónico: epet16rdls@yahoo.com.ar</p>
					</div>
					<div class="col-xs-12 col-sm-4">
						<h4 class="titles subtitles-footer">Siguenos en</h4>
						<ul class="list-unstyled links-footer">
							<li class="text-white me-4"><a  href="https://www.facebook.com/escuelaprovincial.tecnica" class="open-link-newTab" style="color:white" ><i class="fab fa-facebook-f"></i> Facebook</a></li>
							
						</ul>
					</div>
					
				</div>
				
			</div>
			
		</div>
		<div class="my-5" style="background-color: rgba(0, 0, 0, 0.2)">
			<hr>
						<i class="fa fa-copyright"></i>Dpto Informática EPET N°16
						<hr>
					</div>
	</footer>

  

  



  
    
  </div>
</template>

<script>





export default {
  name: 'App'
}
</script>

<style>

.navbar .megamenu{ padding: 1rem; }

/* ============ desktop view ============ */
@media all and (min-width: 992px) {

  .navbar .has-megamenu{position:static!important;}
  .navbar .megamenu{left:0; right:0; width:100%; margin-top:0; color:rgb(15, 14, 14);  }

}	
/* ============ desktop view .end// ============ */

/* ============ mobile view ============ */
@media(max-width: 991px){
  .navbar.fixed-top .navbar-collapse, .navbar.sticky-top .navbar-collapse{
    overflow-y: auto;
      max-height: 90vh;
      margin-top:10px;
      color: ;
  }
}

html, body {
    height: 100%;
    margin: 0;
    padding: 0;
    width: 100%;
    font-family: 'PT Sans Narrow', sans-serif;
    font-size: 16px;
    background-color: #fff;
    position: relative;
}
video{
    width: 100%;
    height: auto;
    display: block;
    border-radius: 4px;
}
.full-reset{
    margin: 0;
    padding: 0;
    width: 100%;
    
}
.font-cover{
    background-color: #fff;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
}
.titles{
    font-family: 'Fjalla One', sans-serif;
}
.center-box{
    margin: 0 auto;
}
.btn-up{
    position: fixed;
    bottom: 2%;
    right: 2%;
    z-index: 9999;
    background: transparent;
    width: 29px;
    height: auto;
    color: #00897B;;
    line-height: 25px;
    font-size: 30px;
    text-align: center;
    border-radius: 50px;
    cursor: pointer;
    text-shadow: 0 0 1px #333;
    display: none;
}
.divider-general{
    width: 100%;
    height: 1px;
    margin: 0;
    padding: 0;
    background-color: #EFCDCD;
}
.table > tbody > tr > td,
.table > thead > tr > th{
    vertical-align: middle;
}
/*************** Estilos del header y nav ***************/
.header{
    background-color: #070661;
    height: 50px;
    color: #fff;
    position: relative;
    z-index: 97;
}
.logo{
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 24px;
    font-family: 'Fjalla One', sans-serif;
    width: 15%;
    position: absolute;
    top: 0;
    left: 0;
}
.navigation{
    height: 50px;
    width: 85%;
    position: absolute;
    top: 0;
    right: 0;
    color: #fff;
}
.navigation ul{
    height: 50px;
    padding-right: 15px;
    text-align: right;
}
.navigation ul li{
    position: relative;
    display: inline-block;
    height: 50px;
    margin: 0;
    padding: 0 1px;
}
.navigation ul li a{
    position: relative;
    text-align: center;
    color: #fff;
    height: 50px;
    width: 100%;
    line-height: 50px;
    font-size: 16px;
    padding: 0 5px;
    cursor: pointer;
    display: block;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.navigation ul li a:active,
.navigation ul li a:focus{
    outline: none;
    text-decoration: none;
}
.navigation ul li a:hover{
    color: #F0F4C3;
    text-decoration: none;
}
.button-menu-mobile{
    margin: 0;
    padding: 0 17px;
    font-size: 25px;
    color: #fff;
    line-height: 50px;
    height: 50px;
    transition: all .3s ease-in-out;
}
.button-menu-mobile:focus,
.button-menu-mobile:active{
    color: #fff;
    outline: none;
}
.button-menu-mobile:hover{
    color: #fff;
}
.mega-menu{
    position: absolute;
    top: 50px;
    left: 0;
    background-color: rgba(40, 11, 105, 0.97);
    color: #fff;
    z-index: 99999;
    border-top: 1px solid rgba(255,255,255,.5);
    padding: 20px 0;
    opacity: 0;
    pointer-events: none;
    transition: .4s all ease-in-out;
}
.mega-menu span{
    color: #F0F4C3;
}
.mega-menu ul{
    padding: 10px 0 0 0;
}
.mega-menu ul li,
.mega-menu ul li a{
    height: 30px;
    line-height: 30px;
}
.mega-menu ul li{
   display: block;
   width: 100%; 
}
.mega-menu ul li a{
    color: #fff;
    -moz-transition: .3s all ease-in-out;
    -ms-transition: .3s all ease-in-out;
    -webkit-transition: .3s all ease-in-out;
    transition: .3s all ease-in-out;
}
.mega-menu ul li a:hover{
    text-decoration: none;
    color: #FFA726;
}
.mega-menu ul li a:active,
.mega-menu ul li a:focus{
    outline: none;
    text-decoration: none;
}
.show-mega-menu{
    opacity: 1;
    height: auto !important;
    pointer-events: auto;
}
.close-mega-menu{
    color: #fff !important;
    position: absolute;
    cursor: pointer;
    right: 15px;
    bottom: 10px;
}
/*************** Estilos del pie de pagina ***************/
.footer{ 
    clear:both;
    color: #fff;
    background-color: #070661;
    position: relative;
    height: auto;
}
.footer-copyright{
    padding: 20px 0 10px 0;
    font-size: 18px;
    text-align: center;
    border-top: 1px solid rgba(255,255,255,.4);
}
.links-footer,
.subtitles-footer{
    padding-left: 50px;
}

.links-footer li a{
    color: #fff;
}
.links-footer li a:hover{
    color: #FFCA28;
    text-decoration: none;
}
.links-footer li a:active,
.links-footer li a:focus{
    outline: none;
    text-decoration: none;
    color: #FFCA28;
}
/*=======================================================================================================
=                                              Estilos index                                            =
========================================================================================================*/
.Logo-Ins-Index img{
    height: 250px;
    margin: 15px auto;
}
.icon-index{
    font-size: 190px;
    margin: 15px;
    transform: rotate(-20deg);
    -moz-transform: rotate(-20deg);
    -ms-transform: rotate(-20deg);
    -webkit-transform: rotate(-20deg);
    display: block;
    text-align: center;
    color: #B0B0B0;
}
/************** Sitios de la institución ***************/
.important-links-index{
    background-color: #F7F7F7; 
    padding: 60px 0;
    height: auto;
}
.important-links-index a{
    border: 1px solid #737373;
    background-color: transparent;
    height: 130px;
    width: 130px;
    display: inline-block;
    border-radius: 50%;
    color: #737373;
    margin: 30px 20px;
    text-align: center;
    transition: .3s all ease-in-out;
    -moz-transition: .3s all ease-in-out;
    -ms-transition: .3s all ease-in-out;
    -webkit-transition: .3s all ease-in-out;
}
.important-links-index a:hover{
    text-decoration: none;
    background-color: #070661;
    border: 1px solid #F57C00;
    transform: scale(1.2);
    -moz-transform: scale(1.2);
    -ms-transform: scale(1.2);
    -webkit-transform: scale(1.2);
}
.important-links-index a:hover p,
.important-links-index a:hover i{
    color: #FFF;
}
.important-links-index a:active,
.important-links-index a:focus{
    outline: none;
    text-decoration: none;
}
.important-links-index a i,
.important-links-index a p{
    transition: .3s all ease-in-out;
    -moz-transition: .3s all ease-in-out;
    -ms-transition: .3s all ease-in-out;
    -webkit-transition: .3s all ease-in-out;
    transform: translateY(25px);
    -moz-transform: translateY(25px);
    -ms-transform: translateY(25px);
    -webkit-transform: translateY(25px);
}
.important-links-index a i{
    font-size: 45px;
}
.important-links-index a p{
    font-size: 18px;
}
/************** Estilos eventos***************/
.events-ins{
    position: relative;
    width: 100%;
    margin: 0;
    padding: 20px 0;
    height: auto;
    background-color: #fff;
}
/*=======================================================================================================
=                                            Estilos institucion                                        =
========================================================================================================*/
/*************** Estilos de la navegacion ***************/
.info-section-ins article{
    padding: 50px 0;
}
.scroll-navigation-ins{
    position: fixed;
    padding-top: 60px;
    height: 100%;
    top: 0;
    right: 0;
    width: 270px;
    border-left: 1px solid #EFCDCD;
    background-color: #F8F8F8;
}
.scroll-navigation-ins ul li{
    display: block;
    width: 100%;
    text-align: center;
    cursor: pointer;
    height: 35px;
    line-height: 35px;
    font-size: 16px;
    margin: 0;
    color: #070661;
    -mos-transition: all .3s ease-in-out;
    -ms-transition: all .3s ease-in-out;
    -webkit-transition: all .3s ease-in-out;
    transition: all .3s ease-in-out;
}
.scroll-navigation-ins ul li:hover{
    -moz-transform: scale(1.2);
    -ms-transform: scale(1.2);
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
    color: #0D47A1;
}
.scroll-navigation-ins figure img{
    height: 100px;
}
#mapa-ins{
    margin: 0;
    padding: 0;
    width: 100%;
    height: 500px;
    border-radius: 4px;
}
/*=======================================================================================================
=                                             Estilos galeria                                           =
========================================================================================================*/
.section-gallery-ins{
    background-color: #fff; 
    padding: 30px 0;
    width: 100%;
}
.section-gallery-ins > article{
    padding-bottom: 30px;
    padding-top: 30px;
}
.section-gallery-ins > article > h2{
    padding-bottom: 40px;
}
.tile-gallery{
    position: relative;
    width: 100%;
    height: auto;
    border-radius: 5px;
    padding: 10px;
    background-color: #F7F7F7;
    border: 1px dashed #EFCDCD;
    margin: 10px 0;
}
.tile-gallery img{
    max-width: 200px;
    max-height: 200px;
    margin: 15px auto;
    display: block;
    border-radius: 50%;
}
.tile-gallery p{
    color: #000000;
}
.tile-gallery span{
    display: block;
    color: #696969;
    margin-bottom: 10px;
}
.tile-gallery a{
    color: #B0B0B0;
    display: block;
    font-size: 19px;
    margin: 10px 0;
    text-align: center;
    transition: .3s all ease-in-out;
    -moz-transition: .3s all ease-in-out;
    -ms-transition: .3s all ease-in-out;
    -webkit-transition: .3s all ease-in-out;
}
.tile-gallery a:hover{
    text-decoration: none;
    transform: scale(1.2);
    -moz-transform: scale(1.2);
    -ms-transform: scale(1.2);
    -webkit-transform: scale(1.2);
    color: #333;
}
.tile-gallery a:active,
.tile-gallery a:focus{
    outline: none;
    text-decoration: none;
}
/*=======================================================================================================
=                                        Media queries                                                  =
========================================================================================================*/

/* col-xs */
@media (max-width: 767px) {
    .font-cover{
        background-attachment: inherit;
    }
    .navigation{
        height: 0;
        width: 100%;
        position: absolute;
        top: 50px;
        background-color: #070661;
        border-top: 1px solid rgba(255,255,255,.2);
        pointer-events: none;
        opacity: 0;
        transition: all .3s ease-in-out;
        -moz-transition: all .3s ease-in-out;
        -webkit-transition: all .3s ease-in-out;
        -ms-transition: all .3s ease-in-out;
        z-index: 99;
    }
    .show-navigations{
        pointer-events: auto;
        opacity: 1;
        height: auto !important;
    }
    .navigation ul{
        height: auto;
        padding-right: 10px;
        padding-left: 10px;
        text-align: left;
    }
    .navigation ul li{
        display: block;
        height: auto;
        padding: 0;
    }
    .navigation ul li a{
         text-align: left;
         height: 40px;
         width: 100%;
         line-height: 40px;
         font-size: 16px;
         padding: 0;
         border-bottom: 1px solid rgba(255,255,255,.2);
    }
    h1{
        font-size: 22px;
    }
    h2{
        font-size: 20px;
    }
    h3{
        font-size: 18px;
    }
    .links-footer,
    .subtitles-footer{
        padding-left: 0;
        text-align: center;
    }
    #mapa-ins{
        margin: 0 auto;
        width: 90%;
        height: 370px;
    }
    .close-mega-menu{
        bottom: 0;
        top: 7px;
    }
    .mega-menu ul{
        margin-bottom: 25px;
    }
}

/* col-sm */
@media (min-width: 768px) and (max-width: 991px) {
    h1{
        font-size: 25px;
    }
    h2{
        font-size: 22px;
    }
    h3{
        font-size: 20px;
    }
    .scroll-navigation-ins{
        width: 235px;
    }
    .Logo-Ins-Index img{
        height: 200px;
    }
}

/* col-md */
@media (min-width: 992px) and (max-width: 1199px) {
    .navigation{
        width: 64%;
    } 
    .logo{
        width: 36%;
        font-size: 20px;
    } 
    .scroll-navigation-ins{
        width: 230px;
    }
}

/* col-lg */
@media (min-width: 1200px) {
    .navigation{
        width: 60%;
    } 
    .logo{
        width: 40%;
    } 
}
div.galeria {
    border: 1px solid #ccc;
    }
    div.galeria:hover {
    border: 1px solid #777;
    }
    div.galeria img {
    width: 30%;
    height: auto;
    }
    div.desc {
    padding: 15px;
    text-align: center;
    }
    * {
    box-sizing: border-box;
    }
    .responsive {
    padding: 0 6px;
    float: left;
    width: 24.99999%;
    }
    @media only screen and (max-width: 700px) {
    .responsive {
    width: 49.99999%;
    margin: 6px 0;
    }
    }
    @media only screen and (max-width: 500px) {
        .responsive {
        width: 50%;
        }
        }
        .clearfix:after {
        content: "";
        display: table;
        clear: both;
        }

</style>



// WEBPACK FOOTER //
// src/App.vue